import ActivateMenu from "./modules/ActivateMenu";
import LocationSwitcher from "./modules/LocationSwitcher";
import FAQAccordian from "./modules/FAQAccordian";
import Header from "./modules/Header";
import ImageDataSrc from "./modules/ImageDataSrc";
import InitFormPopup from "./modules/InitFormPopup";
import InitFormPopupLp from "./modules/InitFormPopupLp";
import InsertRecaptchaScript from "./modules/InsertRecaptchaScript";
import IntlPhone from "./modules/IntlPhone";
import LoadAndResizer from "./modules/LoadAndResizer";
import LoadingAndObserver from "./modules/LoadingAndObserver";
import MegaMenu from "./modules/MegaMenu";
import Tabs from "./modules/Tabs";
import UniversalRangeSlider from "./modules/UniversalRangeSlider";

var sw = window.innerWidth;
var sh = window.innerHeight;

// SVG Convert Code
window.initSvgConvert = function (context = document) {
  // Convert only unprocessed SVGs
  let svgs = context.querySelectorAll("img.svg-convert:not(.svg-done)");

  svgs.forEach((el) => {
    el.classList.add("svg-done"); // mark as processed

    const imgID = el.getAttribute("id");
    const imgClass = el.getAttribute("class");
    const imgURL = el.getAttribute("src");

    fetch(imgURL)
      .then((response) => response.text())
      .then((data) => {
        const parser = new DOMParser();
        const xmlDoc = parser.parseFromString(data, "text/html");
        let svg = xmlDoc.querySelector("svg");
        if (!svg) return;

        if (imgID) svg.setAttribute("id", imgID);
        if (imgClass)
          svg.setAttribute(
            "class",
            imgClass.replace("svg-done", "") + " svg-converted",
          );

        svg.removeAttribute("xmlns:a");

        el.parentNode.replaceChild(svg, el);
      });
  });
};

// Landscape Mode off ---------------- Start
const mql = window.matchMedia("(orientation:landscape)");
mql.addEventListener("change", (event) => {
  if (event.matches) {
    if (innerWidth < 930) {
      // console.log("Now in landscape orientation");
      document.getElementById("portrait-warning").style.display = "flex";
    }
  } else {
    // console.log("Now in portrait orientation");
    document.getElementById("portrait-warning").style.display = "none";
  }
});


document.addEventListener("DOMContentLoaded", () => {
  ImageDataSrc();
  LoadAndResizer();
});

window.addEventListener("load", function () {
  Header();
  MegaMenu();
  LocationSwitcher();
  LoadingAndObserver();
  InitFormPopup();
  InitFormPopupLp();
  ActivateMenu();
  InsertRecaptchaScript();
  FAQAccordian();
  Tabs();

  if (document.querySelectorAll(".phoneiti").length > 0) {
    IntlPhone();
  }

  if (document.querySelectorAll(".range-slider-input")) {
    var containers = document.querySelectorAll(".range-slider-input");
    containers.forEach(function (container) {
      UniversalRangeSlider({
        container: container,
        minInputSelector: "#min-slider-modal",
        maxInputSelector: "#max-slider-modal",
        minLabelSelector: "#min-value-label-modal",
        maxLabelSelector: "#max-value-label-modal",
        hiddenMinInputSelector: "#hidden-min-value-modal",
        hiddenMaxInputSelector: "#hidden-max-value-modal",
        sliderTrackSelector: "#slider-track-modal",
      });
    });
  }
  // Navigation slide Active on a mobile ---------------- Start
  (function () {
    if (document.querySelector("#toggle")) {
      let toggleMenu = document.querySelector("#toggle");
      let htmlEl = document.querySelector("html");

      toggleMenu.addEventListener("click", (event) => {
        // console.log('this', event)
        let _this = event.target;
        _this.classList.toggle("active");
        document.querySelector(".navigation").classList.toggle("open");
        htmlEl.classList.toggle("overflow-hidden");
      });
    }
  })();

  if (document.querySelector(".testimonialSlider")) {
    const testimonialSlider = new Swiper(".testimonialSlider .swiper", {
      slidesPerView: "auto",
      speed: 5000, // controls rewind smoothness
      loop: false, // IMPORTANT
      rewind: true, // smooth back to first slide
      observeParents: true,
      observer: true,
      allowTouchMove: true,
      autoplay: {
        delay: 0, // no pause before rewind
        disableOnInteraction: false,
      },
    });
  }

  // -------------------- Sliders --------------------------

  if (document.querySelector(".blogSlider")) {
    var blogSlider = new Swiper(".blogSlider .swiper", {
      slidesPerView: "auto",
      loop: false,
      speed: 800,
      scrollbar: {
        el: ".blogSlider .swiper-scrollbar",
        hide: false,
        draggable: true,
      },
    });
  }

  /* Left to Right */
  if (document.querySelector(".slider-left")) {
    var leftSlider = new Swiper(".slider-left .swiper", {
      slidesPerView: "auto",
      allowTouchMove: false,
      loop: true,
      watchSlidesProgress: true,
      speed: 8000,
      spaceBetween: 100,
      autoplay: {
        delay: 0,
        disableOnInteraction: false,
      },
      breakpoints: {
        0: {
          spaceBetween: 50,
        },
        576: {
          spaceBetween: 100,
        },
      },
    });
  }

  /* Right to Left */
  if (document.querySelector(".slider-right")) {
    var rightSlider = new Swiper(".slider-right .swiper", {
      slidesPerView: "auto",
      allowTouchMove: false,
      loop: true,
      watchSlidesProgress: true,
      speed: 8000,
      spaceBetween: 100,
      autoplay: {
        delay: 0,
        disableOnInteraction: false,
        //reverseDirection: true,
      },
      breakpoints: {
        0: {
          spaceBetween: 50,
        },
        576: {
          spaceBetween: 100,
        },
      },
    });
  }

  var swiper = new Swiper(".ServicesSlider", {
    slidesPerView: 1,
    spaceBetween: 30,
    centeredSlides: true,
    initialSlide: 1,
    speed: 1200,
    breakpoints: {
      992: {
        spaceBetween: 20,
        slidesPerView: 1.2,
      },
      1025: {
        spaceBetween: 30,
        slidesPerView: 1.6,
      },
    },
  });

  // Keys Takeaways Accordion (JS height based)
  (function () {
    const accordions = document.querySelectorAll(".keys-accordion");
    if (!accordions.length) return;

    accordions.forEach((accordion) => {
      const head = accordion.querySelector(".accordion-head");
      const body = accordion.querySelector(".accordion-body");

      if (!head || !body) return;

      // initial
      body.style.maxHeight = "0px";

      head.addEventListener("click", () => {
        const isActive = accordion.classList.contains("active");

        // close all
        accordions.forEach((acc) => {
          acc.classList.remove("active");
          const b = acc.querySelector(".accordion-body");
          if (b) b.style.maxHeight = "0px";
        });

        // open current
        if (!isActive) {
          accordion.classList.add("active");
          body.style.maxHeight = body.scrollHeight + "px";
        }
      });
    });
  })();

  var swiper = new Swiper(".ServicesThumb", {
    direction: "vertical",
    slidesPerView: 4,
    speed: 1200,
    freeMode: false,
    watchSlidesProgress: true,
    allowTouchMove: true,
    touchReleaseOnEdges: true,
    scrollbar: {
      el: ".ServicesThumbWrapper .swiper-scrollbar",
      draggable: true,
    },
    mousewheel: true,

    breakpoints: {
      576: {
        direction: "vertical",
        slidesPerView: 6,
      },

      1025: {
        slidesPerView: 7,
      },
    },
    on: {
      init: function () {
        if (window.innerWidth >= 576) {
          var slidesCount = this.slides.length;
          var wrapper = document.querySelector(".ServicesThumbWrapper");
          if (wrapper) {
            if (slidesCount < 6) {
              wrapper.classList.add("scroller-add");
            } else {
              wrapper.classList.remove("scroller-add");
            }
          }
        }

        if (window.innerWidth >= 1025) {
          var slidesCount = this.slides.length;
          var wrapper = document.querySelector(".ServicesThumbWrapper");
          if (wrapper) {
            if (slidesCount < 7) {
              wrapper.classList.add("scroller-add");
            } else {
              wrapper.classList.remove("scroller-add");
            }
          }
        }
      },

      resize: function () {
        if (window.innerWidth >= 1025) {
          var slidesCount = this.slides.length;
          var wrapper = document.querySelector(".ServicesThumbWrapper");
          if (wrapper) {
            if (slidesCount < 7) {
              wrapper.classList.add("scroller-add");
            } else {
              wrapper.classList.remove("scroller-add");
            }
          }
        } else {
          var wrapper = document.querySelector(".ServicesThumbWrapper");
          if (wrapper) {
            wrapper.classList.remove("scroller-add");
          }
        }

        if (window.innerWidth >= 576) {
          var slidesCount = this.slides.length;
          var wrapper = document.querySelector(".ServicesThumbWrapper");
          if (wrapper) {
            if (slidesCount < 6) {
              wrapper.classList.add("scroller-add");
            } else {
              wrapper.classList.remove("scroller-add");
            }
          }
        } else {
          var wrapper = document.querySelector(".ServicesThumbWrapper");
          if (wrapper) {
            wrapper.classList.remove("scroller-add");
          }
        }
      },
    },
  });

  var swiper2 = new Swiper(".servicesContentSlider", {
    spaceBetween: 10,
    speed: 1200,
    allowTouchMove: true,
    touchReleaseOnEdges: true,
    thumbs: {
      swiper: swiper,
    },
  });

  // sticky card list
  (function () {
    if (document.querySelector(".stickyCardsListWrapper")) {
      const section = document.querySelector(".stickyCardsListWrapper");
      const cardsWrapper = document.querySelector(
        ".stickyCardsList--cards-wrapper",
      );
      const cards = section.querySelectorAll(".stickyCardsList--card");
      const isMobile = window.matchMedia("(max-width: 992px)").matches;
      const seenCards = new Set();

      if (cards.length === 0 || isMobile) return;

      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            const intersectionRatio = entry.intersectionRatio;
            const currentIndex = [...cards].indexOf(entry.target);
            const activeCard = entry.target;
            // shrink all previous cards
            for (let i = 0; i < currentIndex; i++) {
              const prevCard = cards[i];
              const step = currentIndex - i; // distance from current card
              let scaleDown = 0.95 - (step - 1) * 0.1;
              let scaleUp = scaleDown + 0.1;
              // clamp so it doesn't go above 1
              if (scaleUp > 1) scaleUp = 1;

              if (entry.isIntersecting) {
                if (intersectionRatio >= 0.5) {
                  prevCard.style.transform = `scale(${scaleDown})`;
                  seenCards.add(activeCard);

                  if (step > 5) {
                    prevCard.style.opacity = 0;
                  }

                  if (seenCards.size % 2 === 0) {
                    cardsWrapper.style.transform = `translateY(-${
                      seenCards.size * 1.3
                    }em)`;
                  }
                } else if (intersectionRatio > 0.3 && intersectionRatio < 0.5) {
                  prevCard.style.transform = `scale(${scaleUp})`;
                  activeCard.style.transform = `scale(1)`;
                  seenCards.delete(activeCard);
                  if (step <= 5) {
                    prevCard.style.opacity = 1;
                  }
                }
              }
            }
          });
        },
        { threshold: [0.1, 0.5, 0.85] },
      );
      cards.forEach((card) => {
        observer.observe(card);
      });
    }
  })();

  if (document.querySelector(".testimonialSlider")) {
    var testimonialSlider = new Swiper(".testimonialSlider .swiper", {
      slidesPerView: "auto",
      loop: false,
      speed: 5000,
      freeMode: true,
      loop: true,
      autoplay: {
        delay: 0,
      },
    });
  }

  if (sw > 1199) {
    if (sw < 1400 && sw > 1300 && sh > 900) {
    } else {
      Splitting();

      //Testimonial Section---Start
      setTimeout(() => {
        const testimonialSliders =
          document.querySelectorAll(".testimonialSlider");
        if (testimonialSliders.length > 0) {
          // ✅ check if elements exist
          const testimonialSliderIn = gsap.timeline();
          testimonialSliderIn.to(testimonialSliders, {
            x: "0",
            duration: 1,
          });

          ScrollTrigger.create({
            duration: "100%",
            animation: testimonialSliderIn,
            trigger: ".testimonialsSec",
            start: "top 80%",
            end: "top 45%",
            scrub: 1.5,
            pin: false,
            anticipatePin: 0.5,
          });
        }
      }, 1500);

      //Testimonial Section---End

      //Blog Section---Start
      setTimeout(() => {
        const blogSliders = document.querySelectorAll(".blogSlider");
        if (blogSliders.length > 0) {
          // ✅ check if elements exist
          const blogSliderIn = gsap.timeline();
          blogSliderIn.to(blogSliders, {
            x: "0",
            duration: 1,
          });

          ScrollTrigger.create({
            duration: "100%",
            animation: blogSliderIn,
            trigger: ".blogSection",
            start: "top 80%",
            end: "top 45%",
            scrub: 1.5,
            pin: false,
            anticipatePin: 0.5,
          });
        }
      }, 1500);

      //Blog Section---End

      //Faq Section---Start
      setTimeout(() => {
        const faqsLists = document.querySelectorAll(".faqsList");
        if (faqsLists.length > 0) {
          // ✅ check if elements exist
          const faqsListIn = gsap.timeline();
          faqsListIn.to(faqsLists, {
            x: "0",
            duration: 1,
          });

          ScrollTrigger.create({
            duration: "100%",
            animation: faqsListIn,
            trigger: ".faqSection",
            start: "top 80%",
            end: "top 45%",
            scrub: 1.5,
            pin: false,
            anticipatePin: 0.5,
          });
        }
      }, 1500);

      //Faq Section---End
      // service detail
      // service card section
      setTimeout(() => {
        const serviceCards = document.querySelectorAll(".servicesCardsSec");
        if (serviceCards.length > 0) {
          // ✅ check if elements exist
          const ServiceSliderIn = gsap.timeline();
          ServiceSliderIn.to(serviceCards, {
            x: "0",
            duration: 1,
          });

          ScrollTrigger.create({
            duration: "100%",
            animation: ServiceSliderIn,
            trigger: ".servicesCardsSec",
            start: "top 80%",
            end: "top 45%",
            scrub: 1.5,
            pin: false,
            anticipatePin: 0.5,
          });
        }
      }, 1500);

      // service card section

      // logo
      setTimeout(() => {
        const whatWeDoElements = document.querySelectorAll(".whatWeDo");
        if (whatWeDoElements.length > 0) {
          // ✅ check if elements exist
          const whatWeDoIN = gsap.timeline();

          whatWeDoIN.fromTo(
            whatWeDoElements,
            { x: "-100%" }, // start from LEFT
            { x: "0%", duration: 1 },
            0,
          );

          ScrollTrigger.create({
            animation: whatWeDoIN,
            trigger: ".whatWeDo",
            start: "top 80%",
            end: "top 45%",
            scrub: 1.5,
          });
        }
      }, 1500);

      // logo

      // counter
      setTimeout(() => {
        const counterCards = document.querySelectorAll(
          ".counterWrapper .counterCard",
        );
        if (counterCards.length > 0) {
          // ✅ check if elements exist
          gsap.from(counterCards, {
            scrollTrigger: {
              trigger: ".counterWrapper",
              start: "top 80%",
              end: "top 40%",
              toggleActions: "restart none restart none",
            },
            y: 40,
            opacity: 0,
            duration: 0.8,
            ease: "power3.out",
            stagger: 0.25, // 👈 one by one
          });
        }
      }, 1500);

      // counter

      // service detail thumbslider
      setTimeout(() => {
        const thumbSliders = document.querySelectorAll(".ServicesThumb");
        if (thumbSliders.length > 0) {
          // ✅ check if elements exist
          const thumbSliderServiceIN = gsap.timeline();

          thumbSliderServiceIN.fromTo(
            thumbSliders,
            { x: "-100%" }, // start from LEFT
            { x: "0%", duration: 1 },
            0,
          );

          ScrollTrigger.create({
            animation: thumbSliderServiceIN,
            trigger: ".ServicesThumb",
            start: "top 80%",
            end: "top 45%",
            scrub: 1.5,
          });
        }
      }, 1500);

      // service detail thumbslider

      // service detail thumbslider main
      setTimeout(() => {
        const servicesSlider = document.querySelectorAll(
          ".servicesContentSliderWrapper",
        );
        if (servicesSlider.length > 0) {
          // ✅ check if elements exist
          const servicesContentSliderWrapperIn = gsap.timeline();
          servicesContentSliderWrapperIn.to(servicesSlider, {
            x: "0",
            duration: 1,
          });

          ScrollTrigger.create({
            duration: "100%",
            animation: servicesContentSliderWrapperIn,
            trigger: ".servicesContentSliderWrapper",
            start: "top 80%",
            end: "top 45%",
            scrub: 1.5,
            pin: false,
            anticipatePin: 0.5,
          });
        }
      }, 1500);

      // service detail thumbslider main

      // process cards
      setTimeout(() => {
        const processCards = document.querySelectorAll(
          ".processSec .processCard",
        );
        if (processCards.length > 0) {
          // ✅ check if elements exist
          gsap.from(processCards, {
            scrollTrigger: {
              trigger: ".processSec",
              start: "top 80%",
              end: "top 40%",
              toggleActions: "restart none restart none",
            },
            y: 40,
            opacity: 0,
            duration: 0.8,
            ease: "power3.out",
            stagger: 0.25, // 👈 one by one
          });
        }
      }, 1500);

      // process cards

      // form section
      setTimeout(() => {
        const whiteBgForms = document.querySelectorAll(".whiteBgForm");
        if (whiteBgForms.length > 0) {
          // ✅ check if elements exist
          const whiteBgFormIn = gsap.timeline();
          whiteBgFormIn.to(whiteBgForms, {
            x: "0",
            duration: 1,
          });

          ScrollTrigger.create({
            duration: "100%",
            animation: whiteBgFormIn,
            trigger: ".whiteBgForm",
            start: "top 80%",
            end: "top 45%",
            scrub: 1.5,
            pin: false,
            anticipatePin: 0.5,
          });
        }
      }, 1500);

      // form section

      // service detail

      // case studies listing
      // overview left wrapper
      // animation for text
      setTimeout(() => {
        const fadeElements = document.querySelectorAll(
          ".fadeElementCasestudies",
        );

        if (fadeElements.length > 0) {
          // ✅ only run if elements exist
          fadeElements.forEach((el) => {
            const headings = el.querySelectorAll(".word");
            if (headings.length > 0) {
              // ✅ make sure there are words to animate
              const tl = gsap.timeline().from(headings, {
                x: -40,
                stagger: 0.05,
                autoAlpha: 0,
              });

              ScrollTrigger.create({
                trigger: el,
                start: "top 75%",
                end: "top 65%",
                animation: tl,
                scrub: 2,
                pin: false,
                // markers: true,
              });
            }
          });
        }
      }, 50);

      setTimeout(() => {
        const overviewImages = document.querySelectorAll(
          ".casestudies-overview .img-wrapper",
        );
        if (overviewImages.length > 0) {
          // ✅ check if elements exist
          const casestudiesOverviewRightIn = gsap.timeline();
          casestudiesOverviewRightIn.to(overviewImages, {
            x: "0",
            duration: 1,
          });

          ScrollTrigger.create({
            duration: "100%",
            animation: casestudiesOverviewRightIn,
            trigger: ".casestudies-overview",
            start: "top 80%",
            end: "top 45%",
            scrub: 1.5,
            pin: false,
            anticipatePin: 0.5,
          });
        }
      }, 1500);

      setTimeout(() => {
        const overviewImages = document.querySelectorAll(
          ".casestudy-overview .img-wrapper",
        );
        if (overviewImages.length > 0) {
          // ✅ check if elements exist
          const casestudyOverviewRightIn = gsap.timeline();
          casestudyOverviewRightIn.to(overviewImages, {
            x: "0",
            duration: 1,
          });

          ScrollTrigger.create({
            duration: "100%",
            animation: casestudyOverviewRightIn,
            trigger: ".casestudy-overview",
            start: "top 80%",
            end: "top 45%",
            scrub: 1.5,
            pin: false,
            anticipatePin: 0.5,
          });
        }
      }, 1500);

      setTimeout(() => {
        const deliverableImgs = document.querySelectorAll(
          ".deliverables .main-img",
        );
        if (deliverableImgs.length > 0) {
          // ✅ check if elements exist
          gsap.from(deliverableImgs, {
            scrollTrigger: {
              trigger: ".deliverables",
              start: "top 80%",
              end: "top 40%",
              toggleActions: "restart none restart none",
            },
            y: 40,
            opacity: 0,
            duration: 0.8,
            ease: "power3.out",
            stagger: 0.25, // 👈 one by one
          });
        }
      }, 1500);

      // main img

      // deliverable
      // case studies detail

      // about us
      // overview
      setTimeout(() => {
        const imgWrappers = document.querySelectorAll(
          ".casestudy-video-section .img__wrapper",
        );
        if (imgWrappers.length > 0) {
          // ✅ check if elements exist
          gsap.from(imgWrappers, {
            scrollTrigger: {
              trigger: ".casestudy-video-section",
              start: "top 80%",
              end: "top 40%",
              toggleActions: "restart none restart none",
            },
            y: 40,
            opacity: 0,
            duration: 0.8,
            ease: "power3.out",
            stagger: 0.25, // 👈 one by one
          });
        }
      }, 1500);
      // overview

      // about us

      // blogs listing

      setTimeout(() => {
        const blogCards = document.querySelectorAll(".blogs-listing .blogCard");
        if (blogCards.length > 0) {
          gsap.from(blogCards, {
            scrollTrigger: {
              trigger: ".blogs-listing",
              start: "top 80%",
              end: "top 40%",
              toggleActions: "restart none restart none",
            },
            y: 40,
            opacity: 0,
            duration: 0.8,
            ease: "power3.out",
            stagger: 0.25, // 👈 one by one
          });
        }
      }, 500);
      // blogs listing

      //Footer Section---Start
      setTimeout(() => {
        const rotatingText2 = document.querySelector(".footer .circleLogoText");

        if (rotatingText2) {
          // ✅ check if element exists
          const tt = gsap.to(rotatingText2, {
            rotation: 360,
            duration: 40,
            ease: "none",
            repeat: -1,
          });
          tt.iteration(1000);

          const speedFactor1 = 5;
          let tl2;

          gsap.timeline({
            scrollTrigger: {
              trigger: "html",
              start: "top top",
              end: "+=10000",
              onUpdate: (self2) => {
                if (tl2) tl2.kill();
                tl2 = gsap
                  .timeline()
                  .to(tt, {
                    timeScale: speedFactor1 * self2.direction,
                    duration: 0.1,
                  })
                  .to(tt, { timeScale: self2.direction, duration: 1 }, "+=0.5");
              },
            },
          });
        }
      }, 2500);

      //Footer Section---End
    }
  }

  if (document.querySelector(".workCardsWrapper")) {
    if (sw < 1199 || (sw < 1400 && sw > 1300 && sh > 900)) {
      var workCardsSlider = new Swiper(".workCardsWrapper .swiper", {
        slidesPerView: 1,
        loop: true,
        speed: 800,
        spaceBetween: 15,
      });
    }
  }

  var playBtn = document.querySelector(".play__btn");
  var iframe = document.querySelector(".img__wrapper.is__video iframe");
  if (playBtn && iframe) {
    iframe.style.display = "none"; // Hide iframe initially
    playBtn.addEventListener("click", function () {
      playBtn.style.display = "none";
      iframe.style.display = "block";
    });
  }

  // //////////////////////////////// gsap ////////////////////////////////////////////

  // testimonial slider gsap
  if (sw > 1199) {
    if (sw < 1400 && sw > 1300 && sh > 900) {
    } else {
      setTimeout(() => {
        if (document.querySelector(".testimonialSlider")) {
        const testimonialSliderIn = gsap.timeline();
        testimonialSliderIn.to(
          ".testimonialSlider",
          {
            x: "0",
            duration: 1,
          },

          0,
        );
        ScrollTrigger.create({
          duration: "100%",
          animation: testimonialSliderIn,
          trigger: ".testimonialsSec",
          start: "top 80%",
          end: "top 45%",
          scrub: 1.5,
          pin: false,
          anticipatePin: 0.5,
        });
        }
      }, 1500);
      // testimonial slider gsap

      // remarkable result gsap
    }
  }

  const items = document.querySelectorAll(".purpose-item");

  items.forEach((item) => {
    const content = item.querySelector(".purpose-content");

    // Close all by default
    content.style.height = "0px";

    item.addEventListener("click", () => {
      const isOpen = item.classList.contains("active");

      // Close all items
      items.forEach((i) => {
        i.classList.remove("active");
        i.querySelector(".purpose-content").style.height = "0px";
      });

      // Open clicked one
      if (!isOpen) {
        item.classList.add("active");
        content.style.height = content.scrollHeight + "px";
      }
    });
  });

  // Optional: open first item by default
  if (items.length) {
    const first = items[0];
    const firstContent = first.querySelector(".purpose-content");
    first.classList.add("active");
    firstContent.style.height = firstContent.scrollHeight + "px";
  }

  if (document.querySelector(".technology-slider")) {
    const technologySlider = new Swiper(".technology-slider .swiper", {
      slidesPerView: 3,
      centeredSlides: true,
      loop: true,
      //loopAdditionalSlides: 3, // 🔑 reduces jump
      speed: 1200,
      watchSlidesProgress: true,
      allowTouchMove: true,
      autoplay: {
        delay: 2500,
        disableOnInteraction: false,
      },
    });

    const technologytitleSlider = new Swiper(".title-slider .swiper", {
      slidesPerView: 1,
      loop: false, // ❌ no loop
      speed: 1200,
      effect: "fade",
      fadeEffect: { crossFade: true },
      allowTouchMove: false,
    });

    const technologytextSlider = new Swiper(".genericPanel.bottom .swiper", {
      slidesPerView: 1,
      loop: false, // ❌ no loop
      speed: 1200,
      effect: "fade",
      fadeEffect: { crossFade: true },
      allowTouchMove: false,
    });

    // 🔄 Sync using realIndex (IMPORTANT)
    technologySlider.on("slideChange", () => {
      const index = technologySlider.realIndex;

      technologytitleSlider.slideTo(index);
      technologytextSlider.slideTo(index);
    });
  }

  if (document.querySelector(".authoritySwiper")) {
    var authoritySwiper = new Swiper(".authoritySwiper", {
      speed: 500,
      effect: "cards",
      grabCursor: true,
      loop: false,
      rotate: true,
      navigation: {
        nextEl: ".authority-slider .swiper-button-next",
        prevEl: ".authority-slider .swiper-button-prev",
      },
    });
  }

  if (document.querySelector(".technologyStackSlider")) {
    let technologyStackSlider = document.querySelector(
      ".technologyStackSlider .swiper",
    );
    var technologyStackSliderMain;
    function initTechnologyStackSliderMain() {
      technologyStackSliderMain = new Swiper(technologyStackSlider, {
        slidesPerView: "auto",
        allowTouchMove: false,
        loop: true,
        watchSlidesProgress: true,
        speed: 8000,
        spaceBetween: 15,
        autoplay: {
          delay: 0,
          disableOnInteraction: false,
        },
        breakpoints: {
          576: {
            spaceBetween: 20,
          },
          1024: {
            spaceBetween: 40,
          },
        },
      });
    }
    if (typeof Swiper !== "undefined") {
      initTechnologyStackSliderMain();
    } else {
      window.addEventListener("load", initTechnologyStackSliderMain);
    }
  }

  // contact us space location
  // Set UAE active on load

  const defaultLocation = "ksa";
  const defaultPoint = document.querySelector(
    `.point[data-location="${defaultLocation}"]`,
  );
  const defaultRegion = document.querySelector(
    `.regiosWrapper[data-location="${defaultLocation}"]`,
  );
  if (defaultPoint) defaultPoint.classList.add("active");
  if (defaultRegion) defaultRegion.classList.add("active");

  document.querySelectorAll(".point").forEach((point) => {
    point.addEventListener("click", () => {
      const location = point.getAttribute("data-location");

      // Remove active from all points
      document
        .querySelectorAll(".point")
        .forEach((p) => p.classList.remove("active"));

      // Add active to clicked point
      point.classList.add("active");

      // Remove active from all region wrappers
      document
        .querySelectorAll(".regiosWrapper")
        .forEach((region) => region.classList.remove("active"));

      // Add active to matching region wrapper
      const matchingRegion = document.querySelector(
        `.regiosWrapper[data-location="${location}"]`,
      );
      if (matchingRegion) {
        matchingRegion.classList.add("active");
      }
    });
  });

  (function () {
    var links = document.querySelectorAll("a.js-mailto-link");
    if (!links.length) return;
    links.forEach(function (link) {
      link.addEventListener("click", function (e) {
        if (
          this.hasAttribute("data-mail-user") &&
          this.hasAttribute("data-mail-domain")
        ) {
          e.preventDefault();
          var user = this.getAttribute("data-mail-user") || "";
          var domain = this.getAttribute("data-mail-domain") || "";
          var params = this.getAttribute("data-mail-params") || "";
          if (!user || !domain) return;
          var addr = user + "@" + domain;
          var href = "mailto:" + addr + (params ? "?" + params : "");
          window.location.href = href;
        }
      });
    });
  })();
});
